export const helper = {

    data(){
        return {

        }
    },
    methods:{
        isSmallTouchDevice(){
            let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
            return width<700;
            //return ("ontouchstart" in document.documentElement);
        },
        isMobileTouchDevice(){
			return  ("ontouchstart" in document.documentElement);
		},
        getArrayAsString(dataset,ids){
			let res=this.getAsStringArray(dataset,ids);
			if(this._.isArray(res)){
				res=this._.join(res," | ");
			}
			return res;
        },
        getAsStringArray(dataset,ids){
			let res="";
			if(this._.isArray(ids)){
				res=this._.filter(dataset,(c)=> { return this._.includes(ids, c.id) });
				res=this._.map(res, 'name');
			}
			return res;
        },
        compareIdWithIds(ids,id){
			let res=false;
			if(this._.isArray(ids)){
				res=this._.includes(ids, id);
			}
			return res;
        },
        getModifiedImage(img){
			if(this._.isString(img)){
                img=img.replace("https://drive.google.com/open", "https://drive.google.com/uc");
                if(img.startsWith('/')){
                    img="https://vontablern.de"+img;
                }
			}else{
				img="";
			}
			return img;
        },
        filterEmptyData(data){
            return this._.filter(data,(d)=>{
                return (d!=""&&d!="0" && d!=null);
            });
        },
        scrollToTop () {
            //window.scrollTo(0, 0)
        },
        newUuid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        getShopsWithAttrCount(catId,dataset,attr){
			if(null!=catId && dataset && attr){
				let res= this._.filter(dataset,(shop)=>{
					return this.compareWithCategories(shop[attr],catId);
				});

				return res.length;
			}
			return 0;
        },
        removeSpecialCharsFromString(str) {
            if(this._.isString(str)){
              str = str.replace(/^\s+|\s+$/g, ''); // trim
              str = str.toLowerCase();
            
              // remove accents, swap ñ for n, etc
              var from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
              var to   = "aaaaaeeeeeiiiiooooouuuunc------";
              for (var i=0, l=from.length ; i<l ; i++) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
              }
            
              str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-') // collapse whitespace and replace by -
                .replace(/-+/g, '-'); // collapse dashes
              }
            return str;
          }
    }
}